module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAhklEQVR4Ae3O3QmAIBDAcT8WaIRGaMRGaIPaoBEcRdpBEH2x88GgiDw/6iH8g3AI9+MIaf07rXVvjFmttbOfMTsMgzLGBKV0c851nHOBxWOXSnhj+IN5gctlNn6HFuNPaDaOQZPxFBSN56BRvAQNATyd8BpoyBsHXgu94kQpNZDKvWG2PmwH1qrRzP0lk0IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right/7.png
// module id = zVST
// module chunks = 25